import { render, staticRenderFns } from "./cPieStyle.vue?vue&type=template&id=c24b088e&scoped=true&"
import script from "./cPieStyle.vue?vue&type=script&lang=js&"
export * from "./cPieStyle.vue?vue&type=script&lang=js&"
import style0 from "./cPieStyle.vue?vue&type=style&index=0&id=c24b088e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c24b088e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/ljz/work-project/bi-base/biDashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c24b088e')) {
      api.createRecord('c24b088e', component.options)
    } else {
      api.reload('c24b088e', component.options)
    }
    module.hot.accept("./cPieStyle.vue?vue&type=template&id=c24b088e&scoped=true&", function () {
      api.rerender('c24b088e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/styleComp/cPieStyle.vue"
export default component.exports